import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "holding-expand__debt" }
const _hoisted_2 = {
  key: 0,
  class: "holding-expand__empty"
}
const _hoisted_3 = { class: "holding-expand__row-left" }
const _hoisted_4 = { class: "holding-expand__row-count" }
const _hoisted_5 = { class: "holding-expand__row-name" }
const _hoisted_6 = { class: "holding-expand__row-address" }

import { formatMoney } from "@/utils/format";
import { computed, ref } from "vue";
import ExpandListModal from "@/components/common/modal/ExpandListModal.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { clientPageStore } from "@/store/client-page";


export default /*@__PURE__*/_defineComponent({
  __name: 'HoldingExpandModal',
  setup(__props, { expose: __expose }) {

const clientStore = clientPageStore()

const client = computed(() => clientStore.openedClient)
const canEdit = computed(() => client.value?.UnionAccess === 2)

const filter = ref('')

const filteredClients = computed(() => {
	const list = client.value?.UnionClients ?? []
	const q = filter.value.trim().toLowerCase()
	if (!q) {
		return list
	}
	return list.filter((uc: any) =>
		`${uc.Name ?? ''} ${uc.Address ?? ''}`.toLowerCase().includes(q)
	)
})

const $modal = ref<InstanceType<typeof ExpandListModal> | null>(null)

const onOpen = () => {
	filter.value = ''
	$modal.value?.onOpen()
}
const onClose = () => $modal.value?.onClose()

const onDetach = async (id: number) => {
	try {
		await clientStore.detachClientFromUnion(id)
	} catch (e) {
		console.error(e)
	}
}

__expose({ onOpen, onClose })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(ExpandListModal, {
    ref_key: "$modal",
    ref: $modal,
    title: _ctx.$t('holding'),
    placeholder: _ctx.$t('name_or_address'),
    filter: filter.value,
    "onUpdate:filter": _cache[0] || (_cache[0] = ($event: any) => (filter.value = $event))
  }, {
    summary: _withCtx(() => [
      _createTextVNode(" [" + _toDisplayString(_ctx.$t('client_revenue_label')) + " ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("span", { style: { margin: '0 1px' } }, "/", -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('client_debt_label')) + ": " + _toDisplayString(_unref(formatMoney)(client.value?.UnionRevenue ?? 0)) + " ", 1),
      _cache[2] || (_cache[2] = _createElementVNode("span", { style: { margin: '0 1px' } }, "/", -1)),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(formatMoney)(client.value?.UnionDebt ?? 0)), 1),
      _cache[3] || (_cache[3] = _createTextVNode("] "))
    ]),
    default: _withCtx(() => [
      (!filteredClients.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('nothing_found')), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredClients.value, (uc, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: uc.Id,
          class: "holding-expand__row"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(index + 1) + ".", 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                class: "holding-expand__row-name-str",
                to: { query: { page: 'client', id: uc.Id } },
                onClick: onClose
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(uc.Name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("span", _hoisted_6, [
                _createTextVNode(" (" + _toDisplayString(uc.Address) + ") ", 1),
                (canEdit.value)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 0,
                      text: _ctx.$t('remove')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          class: "holding-expand__row-icon",
                          style: { marginTop: '-2px' },
                          name: "close-bold",
                          width: "12px",
                          color: "#D2D2D2",
                          "hover-color": "#BA4C4C",
                          cursor: "pointer",
                          onClick: ($event: any) => (onDetach(uc.Id))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["text"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title", "placeholder", "filter"]))
}
}

})